import { useAws } from "src/networking/aws/aws.hook";
import {
  AwsGateCallbacks,
  AwsGateRequest,
  PostCreateDossier,
  PostSendDossier,
  GetCheckSignStatus,
  ServiceType,
} from "src/types";

export const usePostCreateDossier = <
  T extends PostCreateDossier["request"],
  D extends PostCreateDossier["response"],
>() => {
  const hook = useAws<T, D>("postCreateDossier", ServiceType.COMMUNICATION);

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      return hook.crossGate(
        {
          method: "post",
          path: "/dossier/create",
          ...request,
        },
        callbacks
      );
    },
  };
};

export const usePostSendDossier = <
  T extends PostSendDossier["request"],
  D extends PostSendDossier["response"],
>() => {
  const hook = useAws<T, D>("postSendDossier", ServiceType.COMMUNICATION);

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      return hook.crossGate(
        {
          method: "post",
          path: "/dossier/send",
          ...request,
        },
        callbacks
      );
    },
  };
};

export const useGetCheckSignStatus = <
T extends GetCheckSignStatus["request"],
D extends GetCheckSignStatus["response"],
>() => {
  const hook = useAws<T,D>("getCheckSignStatus", ServiceType.COMMUNICATION);

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      const draftId = request.pathParams.idBozza;

      return hook.crossGate(
        {
          method: "get",
          path: `/dossier/check/${draftId}`,
          ...request,
        },
        callbacks
      );
    },
  };
};
